<template>
  <section class="section">
    <div class="row">
      <div class="col-lg-12">

        <div class="card">
          <div class="card-body">
            <h5 class="card-title">Dashboard</h5>
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li
                  class="nav-item"
                  role="presentation"
                  v-for="cur in currencies"
              >
                <router-link
                    :to="{ name: 'Dashboard', params: { currency: cur } }"
                    :class="{'nav-link': true, 'active': cur === props.currency}"
                    :id="cur"
                    type="button" role="tab" aria-controls="home" aria-selected="true"
                >
                  {{ cur }}
                </router-link>
              </li>
            </ul>


            <DashboardFilter
                :initial="filter"
                :accounts="accounts"
                @applyFilter="applyFilter"
                @clearFilter="clearFilter"
            />
          </div>
        </div>
      </div>
    </div>

    <DashboardCard
        title-expense="Расходы"
        title-income="Доходы"
        :card="card"
    />
  </section>
</template>

<script setup>
import {onMounted, reactive, watch} from "vue";
import {useDashboard} from "@/features/dashboard/composables/useDashboard";
import DashboardFilter from "@/features/dashboard/components/DashboardFilter.vue";
import DashboardCard from "@/features/dashboard/components/DashboardCard.vue";

const {
  router,
  route,
  currencies,
  accounts,
  card,

  dashboard,
  currencyList,
  accountList
} = useDashboard();

const props = defineProps({
  currency: {
    type: String,
    required: true,
  },
});

const filter = reactive({
  accountIds: route.query.accountIds ?? '',
  createdAtFrom: route.query.createdAtFrom ?? '',
  createdAtTo: route.query.createdAtTo ?? '',
});

onMounted(async () => {
  await Promise.all([currencyList(), dashboard(props.currency, filter), accountList(props.currency)]);
});

watch(
    () => route.query,
    (q) => {
      filter.accountIds = q.accountIds ?? '';
      filter.createdAtFrom = q.createdAtFrom ?? '';
      filter.createdAtTo = q.createdAtTo ?? '';

      dashboard(props.currency, filter);
      accountList(props.currency);
    }
);

const applyFilter = (payload) => {
  const query = {};
  Object.entries(payload).forEach(([key, value]) => {
    if (value) {
      query[key] = value;
    }
  });
  router.replace({
    query: query,
  });
}

const clearFilter = () => {
  filter.accountIds = [];
  filter.createdAtFrom = '';
  filter.createdAtTo = '';
  router.replace({
    query: {},
  });
}
</script>

<style scoped>

</style>